import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get, set, find } from 'lodash';
import queryString from 'qs';

import MovieReport from './MovieReport';
import { selectBenchmarks } from '../../reducers/filters-reducer';

import config from '../configs/movies-config';

import * as queryActions from '../../actions/query-actions';
import * as filtersActions from '../../actions/filters-actions';
import * as movieActions from '../../actions/movie-actions';

import { getMovie } from '../../reducers/movie-reducer';

import { getLooks } from '../../reducers/embed-reducer';
import { getInlineQueryResults } from '../../reducers/query-reducer';

const {
  looks: viewershipLooks,
  queries: viewershipQueries
} = config.MOVIE_REPORT_FILTERS.movieReportViewership;

const {
  looks: engagementLooks,
  queries: engagementQueries
} = config.MOVIE_REPORT_FILTERS.movieReportEngagement;

const {
  queries: anticipationQueries
} = config.MOVIE_REPORT_FILTERS.movieReportAnticipation;

const {
  queries: affinityQueries
} = config.MOVIE_REPORT_FILTERS.movieReportAffinity;

const mapStateToProps = (state, ownProps) => {
  const movieId = get(ownProps, 'match.params.movieId', '');
  const movie = getMovie(movieId, state);
  const query = queryString.parse(
    get(state, 'router.location.search', '').slice(1)
  );

  const findSelectedBenchmark = (bms, q) => {
    const bm = get(q, 'benchmark', null);
    const defaultBenchmark = find(bms, b => b.isDefault);

    if (bm) {
      return bm;
    } else if (defaultBenchmark) {
      return defaultBenchmark.uuid;
    }

    return null;
  };

  const benchmarks = selectBenchmarks(state);

  const getMovieFilters = (filters, movieId) => {
    const currentMovieId = get(filters, 'fields.movie.value');
    if (currentMovieId && movieId && currentMovieId !== movieId) {
      set(filters, 'fields.movie.value', {
        label: '',
        value: movieId
      });
    }
    return { ...filters };
  };

  return {
    selectedBenchmark: findSelectedBenchmark(benchmarks, query),
    benchmarks,
    viewershipLooks: getLooks(viewershipLooks, state),
    viewershipQueries: getInlineQueryResults(viewershipQueries, state),

    engagementLooks: getLooks(engagementLooks, state),
    engagementQueries: getInlineQueryResults(engagementQueries, state),

    anticipationQueries: getInlineQueryResults(anticipationQueries, state),
    affinityQueries: getInlineQueryResults(affinityQueries, state),

    filters: getMovieFilters(state.filters, movieId),

    movie
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const movieId = get(ownProps, 'match.params.movieId', '');
  return {
    fetchMovie: () => dispatch(movieActions.getMovieData(movieId)),
    movieId,
    filtersActions: bindActionCreators(filtersActions, dispatch),
    queryActions: bindActionCreators(queryActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MovieReport);
